import { useParams } from 'react-router-dom';

import {
  isErrorWithMessage,
  openErrorNotification,
  openSuccessNotification,
  getServerErrorText,
} from 'shared/lib';

import { EmptyData, ErrorMessage } from 'shared/ui';

import {
  type CpoDto,
  type CpoFormData,
  useGetCpoQuery,
  useUpdateCpoMutation,
  ConnectedCpoForm,
  prepareRequestData,
} from 'entities/cpo';

import { EDIT_ERROR, EDIT_SUCCESS } from '../consts';

const getInitialValues = (cpo: CpoDto): CpoFormData => {
  const { isDeleted, isMain, ocpiHubId, ownerId, id, ...rest } = cpo;

  return {
    ...rest,
    id: String(id),
    ocpiHubId: String(ocpiHubId),
    ownerId: String(ownerId),
  };
};

export function EditCpo() {
  const [trigger, { isLoading: isMutationLoading }] = useUpdateCpoMutation();

  const { cpoId } = useParams() as { cpoId: string };

  const { isFetching, error, data } = useGetCpoQuery({ id: cpoId });

  const handleSubmit = async (values: CpoFormData) => {
    const req = prepareRequestData(values);

    try {
      const res = await trigger(req).unwrap();

      // костыль
      if (res.statusCode !== 0) {
        openErrorNotification(res.statusDescription);
        return;
      }
      //

      openSuccessNotification(EDIT_SUCCESS);
    } catch (err) {
      const hasErrorMessage = isErrorWithMessage(err);

      const errorText = hasErrorMessage
        ? err.data.statusDescription
        : EDIT_ERROR;

      openErrorNotification(errorText);
    }
  };

  if (isFetching) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <ErrorMessage text={getServerErrorText(error)} />;
  }

  if (data && data.statusCode !== 0) {
    return <ErrorMessage text={data.statusDescription} />;
  }

  if (!data?.cpo) {
    return <EmptyData />;
  }

  const initialValues = getInitialValues(data.cpo);

  return (
    <ConnectedCpoForm
      handleSubmit={handleSubmit}
      loading={isMutationLoading}
      initialValues={initialValues}
      title={data.cpo.name}
      disabled
    />
  );
}
